const deviceIdCookieName = 'CBS_DEVICEID';
import { setCookie } from 'helpers/VanillaCookie';

const setupDeviceIdCookie = () => {
    // If cookie is already set, do nothing
    if (document.cookie.indexOf(deviceIdCookieName) !== -1) {
        return;
    }

    window.addEventListener('load', onLoad);
};

function onLoad(event) {
    try {
        // Delay the call to allow the alloy object to be available
        const delay = 1000;

        this.setTimeout(() => {
            // alloy is an adobe function injected into the page through
            // tealium by MOPS team.
            // See CBSCOMSUB-9248 for more details
            alloy('getIdentity')
                .then((result) => {
                    setDeviceIdCookie(result.identity.ECID);
                })
                .catch((err) => {});
        }, delay);
    } catch (error) {}
}

function setDeviceIdCookie(ecid) {
    try {
        let cookieOptions = {
            path: '/',
        };
        setCookie(deviceIdCookieName, ecid, cookieOptions);
    } catch (error) {}
}

export { setupDeviceIdCookie };
